<template>

    <v-layout>

        <v-select
              class="mwst-select"
              @change="triggerMwStChange"
            :tabindex="tabindex"
            box
            v-model="steuersatz"
            :items="steuersaetze"
            item-text="val"
            item-value="key"
            label="Steuersatz"
            return-object
              :append-icon="'icon-arrow_drop_down'"
        >
            <template slot="selection" slot-scope="data">
                <div>
                {{ data.item.val }} %
                </div>
            </template>
            <template slot="item" slot-scope="data">
                <div>
                {{ data.item.val }} %
                </div>
            </template>
        </v-select>


        <v-menu bottom disabled left>
            <v-btn
                class="mt-2 mr-0"
                slot="activator"
                depressed
                disabled
                flat
                icon
            >
                <!--<v-icon>mdi-dots-vertical</v-icon>-->
            </v-btn>

            <!--<v-list>
                <v-list-tile to="/steuersaetze">
                    <v-list-tile-title><v-icon class="mr-3">mdi-pencil</v-icon>Steuersätze bearbeiten</v-list-tile-title>
                </v-list-tile>
            </v-list>-->
        </v-menu>



        <!--<v-btn

              class="mt-2"
              color="green"
              fab small
        >
            <v-icon class="white&#45;&#45;text">mdi-pencil</v-icon>
        </v-btn>-->

    </v-layout>


</template>


<script>

    export default {
        name: 'SelectSteuersatz',
        props: ['tabindex'],

        data: () => ({
        }),
        computed: {
            steuersatz: {
                get() {
                    return this.$store.getters.steuersatz;
                },
                set(val) {
                    this.$store.dispatch("steuersatz", val);
                }
            },
            steuersaetze: {
                get() {
                    return this.$store.getters.steuersaetze;
                }
            }
        },
        methods: {
            triggerMwStChange() {
                this.$emit("changedMwst", null);
            }
        }
    }
</script>

<style scoped>

</style>
